import React from 'react';

import classNames from 'classnames';

import ContactSelector from 'bundles/backoffice/contacts/selector';
import { getPortaledMenuProps, horizontalFormStyles } from 'helpers/react_select_helpers';

import type { Contact } from 'bundles/backoffice/contacts/types';
import type { FormContact } from 'bundles/backoffice/contacts/forms/types';

interface Props {
  allowSavingPrivateContacts?: boolean;
  business: Contact | null;
  className?: string;
  contact: FormContact;
  onChange: (business: Contact | null) => void;
}

export default function ContactFormBusinessInput({
  allowSavingPrivateContacts, business, className, contact, onChange
}: Props) {
  return (
    <div className={classNames('form-group', className)}>
      <div className="control-label">Company</div>
      <ContactSelector
        {...getPortaledMenuProps(horizontalFormStyles)}
        contact={business}
        contactType="business"
        menuPlacement="top"
        newContactVisibility={!allowSavingPrivateContacts && contact.private ? 'shared' : contact.visibility}
        onChange={onChange}
      />
    </div>
  );
}
